import type { PaletteOptions } from '@material-ui/core/styles/createPalette';

import colors from './colors';

/**
 * The palette enables you to modify the color of the components to suit your brand.
 *
 * https://material-ui.com/customization/palette/
 */
const palette: PaletteOptions = {
  background: {
    default: colors.grey50,
  },
  primary: {
    light: colors.primaryLight,
    main: colors.primaryMain,
    dark: colors.primaryDark,
  },
  secondary: {
    light: colors.secondaryLight,
    main: colors.secondaryMain,
    dark: colors.secondaryDark,
  },
  error: {
    light: colors.errorLight,
    main: colors.errorMain,
    dark: colors.errorDark,
  },
  warning: {
    light: colors.warningLight,
    main: colors.warningMain,
    dark: colors.warningDark,
  },
  info: {
    light: colors.infoLight,
    main: colors.infoMain,
    dark: colors.infoDark,
  },
  success: {
    light: colors.successLight,
    main: colors.successMain,
    dark: colors.successDark,
  },
  grey: {
    50: colors.grey50,
    100: colors.grey100,
    200: colors.grey200,
    300: colors.grey300,
    400: colors.grey400,
    500: colors.grey500,
    600: colors.grey600,
    700: colors.grey700,
    800: colors.grey800,
    900: colors.grey900,
  },
  text: {
    primary: colors.grey900,
    secondary: colors.grey700,
  },
};

export default palette;
